import React from 'react'
import { shallow } from 'enzyme'
import { SmartRateDisplay } from '../SmartRateDisplay'
import AlertTriangle from '../../common/icons/AlertTriangle'
import Spinner from '../../common/Spinner'
import Modal from '../../common/Modal'
import PermutationDots from '../helpers/PermutationDots'
import truncateFloat from '../../common/helpers/truncateFloat'

describe('<SmartRateDisplay />', () => {
  let wrapper, instance, props
  beforeEach(() => {
    props = {
      businessName: 'test biz',
      color: 'orange',
      dataPermutation: 'credit',
      defaultProbability: 0.1,
      error: undefined,
      loanId: 1,
      needsRedecision: false,
      parentComponent: 'loanStatusHeader',
      productUsesDefaultModel: true,
      smartRate: 3,
      toggleDraggable: null
    }
    wrapper = shallow(<SmartRateDisplay {...props} />)
    instance = wrapper.instance()
  })
  describe('#toggleSmartRateModal', () => {
    describe('when isSmartRateModalOpen is false', () => {
      beforeEach(() => {
        wrapper.setState({ isSmartRateModalOpen: false })
      })
      it('should change isSmartRateModalOpen to true', () => {
        instance.toggleSmartRateModal()
        expect(wrapper.state('isSmartRateModalOpen')).toBe(true)
      })
    })
    describe('when isSmartRateModalOpen is true', () => {
      beforeEach(() => {
        wrapper.setState({ isSmartRateModalOpen: true })
      })
      it('should change isSmartRateModalOpen to false', () => {
        instance.toggleSmartRateModal()
        expect(wrapper.state('isSmartRateModalOpen')).toBe(false)
      })
    })
  })
  describe('toggleModal', () => {
    it('should call toggleSmartRateModal', () => {
      instance.toggleSmartRateModal = jest.fn()
      instance.toggleModal()
      expect(instance.toggleSmartRateModal).toHaveBeenCalledTimes(1)
    })
    describe('when the toggleDraggable prop is present', () => {
      beforeEach(() => {
        wrapper.setProps({ toggleDraggable: jest.fn() })
        wrapper.update()
      })
    })
  })
  describe('render', () => {
    describe('when it is loading', () => {
      beforeEach(() => {
        wrapper.setProps({ loading: true })
      })
      it('should render a <Spinner />', () => {
        expect(wrapper.find(Spinner)).toHaveLength(1)
      })
    })
    describe('when there is an error and no smartRate', () => {
      beforeEach(() => {
        wrapper.setProps({ error: {}, smartRate: null})
      })
      it('should render an <AlertTriangle />', () => {
        expect(wrapper.find(AlertTriangle)).toHaveLength(1)
      })
    })
    describe('when it is not loading, there is no error, and there is a smartRate', () => {
      it('should render a <Modal />', () => {
        expect(wrapper.find(Modal)).toHaveLength(1)
      })
      it('should render the loan\'s smart rate', () => {
        expect(wrapper.find('#smart_rate').text()).toBe(props.smartRate.toString())
      })
      describe('when there is a dataPermutation and color', () => {
        beforeEach(() => {
          wrapper.setProps({ dataPermutation: 'credit', color: 'orange' })
        })
        it('should render a <PermutationDots />', () => {
          expect(wrapper.find(PermutationDots)).toHaveLength(1)
        })
      })
      describe('when the product is enabled for the default model and there is no error', () => {
        beforeEach(() => {
          wrapper.setProps({ productUsesDefaultModel: true, error: null })
        })
        describe('when the loan does not need to be redecisioned', () => {
          describe('when there is a default probability', () => {
            beforeEach(() => {
              wrapper.setProps({ defaultProbability: 0.1 })
            })
            it('should render a default probability', () => {
              expect(wrapper.find('#default_probability').text()).toBe(`${truncateFloat({ float: props.defaultProbability * 100, n: 1, truncateZeroes: true })}%`)
            })
          })
          describe('when there is no default probability', () => {
            beforeEach(() => {
              wrapper.setProps({ defaultProbability: null })
            })
            it('should render a question mark', () => {
              expect(wrapper.find('#default_probability').text()).toBe('?')
            })
          })
        })
      })
      describe('when the product is enabled for the default model, there is a smart rate, and there is an error', () => {
        beforeEach(() => {
          wrapper.setProps({ error: {}, smartRate: 3, productUsesDefaultModel: true })
        })
        it('should render an <AlertTriangle />', () => {
          expect(wrapper.find('SmartRateDisplay__ErrorAlert')).toHaveLength(1)
        })
      })
    })
  })
})
